import React from "react";
import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import Image from "@components/item/Image";
// @ts-ignore
import { faker } from "@faker-js/faker";
import { useTheme } from "@emotion/react";

const SwiperContainer = styled(Swiper)(({ theme }) => ({
  position: "relative",
  maxWidth: "560px",
  width: "100%",
  height: "36.8rem",
  maxHeight: "100dvh",

  ".swiper-pagination": {
    bottom: "2rem",
    whiteSpace: "nowrap",
    padding: "0 2rem",
  },
  ".swiper-pagination-bullet": {
    minWidth: "30px",
    height: "2px",
    backgroundColor: theme.color.white,
    borderRadius: "0",
  },
  ".swiper-pagination-bullet-active": {
    backgroundColor: theme.color.black,
  },
}));

const ImageWrapper = styled.div({
  position: "relative",
  width: "100%",
  height: "100%",

  "::after": {
    content: `""`,
    display: "block",
    paddingTop: "100%",
  },
});

const ImageItem = styled.div({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
});

type Props = {
  imageList?: { image_url: string }[];
};

const ProductSwiper = ({ imageList }: Props) => {
  const theme = useTheme();

  return (
    <SwiperContainer
      modules={[Pagination]}
      slidesPerView={1}
      centeredSlides={false}
      pagination={{ clickable: false }}>
      {imageList?.map((item, index) => (
        <SwiperSlide key={index}>
          <ImageWrapper>
            <ImageItem>
              <Image src={item.image_url} width="100%" height="36.8rem" />
            </ImageItem>
          </ImageWrapper>
        </SwiperSlide>
      ))}
    </SwiperContainer>
  );
};

export default ProductSwiper;
